import { useUserStore } from '@frontend/libs/stores/useUserStore'
import { generateUuidList } from '@frontend/libs/utils'

import ProductItemLoader from '../../products/components/product-item/ProductItemLoader'

export const ShopLoader = () => {
  const { shopGridView } = useUserStore((state) => state)

  return (
    <>
      {generateUuidList(shopGridView === 'three-col' ? 6 : 8).map((item) => (
        // eslint-disable-next-line react/jsx-no-undef
        <ProductItemLoader key={item} />
      ))}
    </>
  )
}

export default ShopLoader
